export const READ_LEADERBOARD = 'Leaderboard.Read';
export const READ_LEADERBOARD_SUCCESS = 'Leaderboard.Read.Success';
export const READ_LEADERBOARD_FAIL = 'Leaderboard.Read.Fail';


// WEBPACK FOOTER //
// ./src/Types/Leaderboard.js